// dermaRollerData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const dermaRoller: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Derma Roller -",
            "description": "A good skincare always helps to keep skin healthy and refreshed. However, at times we need professional treatment for lasting results and different types of",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/derma-roller/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Derma Roller -",
                "description": "A good skincare always helps to keep skin healthy and refreshed. However, at times we need professional treatment for lasting results and different types of",
                "url": "https://elitebodyhome.com/services/derma-roller/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T09:29:41+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Banner-Image-large.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Banner-Image-large.jpg",
                "image_width": 1024,
                "image_height": 320,
                "image_alt": "Derma Roller",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Derma Roller -",
                "description": "A good skincare always helps to keep skin healthy and refreshed. However, at times we need professional treatment for lasting results and different types of",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Banner-Image-large.jpg"
            },
        },
        "breadcrumbs": ["Home", "Services", "Derma Roller"],
        "hero": {
            "title": "Derma Roller Treatment",
            "subtitle": "Best Derma Roller Treatment in Dubai",
            "description": "Real fresh still only one tip for a good skincare. But sometimes we need professional treatment for long-lasting results and other varieties of skin problems. Derma Roller treatment is your ultimate solution for various skin care problems like sun damage, scars, stretch marks, wrinkles, fine lines etc. We provide the best Derma Roller in Dubai at Elite Body Home to relieve you of all the skin problems and make you have flawless skin."
        },
        "howItWorks": {
            "title": "What Is This Treatment Called, Derma Roller Treatment?",
            "description": "Derma Roller treatment is an excellent and unique choice that can help in enhancing the skin properties and healing it from within. Prepare yourself for a new appearance, without scars, wrinkles, stretch marks or fine lines. Essentially, it's a micro-needling technology that stimulates collagen production. At one end of the derma roller are some very small and minute needles. It creates holes in the skin which help to remove scars spots or any skin related issue."
        },
        "procedureSteps": {
            "heading": "Derma Roller Procedure Steps",
            "para": "Here is how the whole process goes. Not too complex! But in a simpler way you achieve results that separates your skin and ultimate.",
            "steps": [
                {
                    "title": "Consultation from the Experts",
                    "desc": "We have a team of dermatologists who scrub and swab the patient's skin first. They provide good consultation from top-notch experts so that you can know more, and they tell you well what are the results with an edge and gives the best.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Applying Anesthesia",
                    "desc": "A topical anesthetic cream is applied on the treatment area half an hour before.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Dermarolling Procedure",
                    "desc": "Removing the cream, the therapist would proceed to the derma rolling process. This usually takes about 10 to 30 minutes.",
                    "icon": "fa-solid fa-roller"
                },
                {
                    "title": "Moving of Roller",
                    "desc": "After that, the roller is rolled against the skin several times to create micro injuries in the skin.",
                    "icon": "fa-solid fa-repeat"
                },
                {
                    "title": "Cleansing",
                    "desc": "The last stage would be cleansing of the skin. Then a moisturizing cream is applied with this.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "The treatment has many advantages that can give you a glowing and healthy complexion.",
            "items": [
                {
                    "title": "One-Stop Solution",
                    "desc": "When you go for Derma Roller treatment all skin problems like wrinkles, fine lines, stretch marks, hyperpigmentation, etc.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Fast Recovery",
                    "desc": "You don't need every minute of downtime, and recovery time is not significant. Well, Get the quickest recovery of your skin and give it a good and yunki glow.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Look Amazing",
                    "desc": "Derma Roller treatment in Dubai helps those who are suffering from skin issue to take care of skin in order to have a good and healthier look.",
                    "icon": "fa-solid fa-face-grin-stars"
                }
            ]
        },
        "eligibility": {
            "heading": "Who's the Ideal Candidate?",
            "subheading": "",
            "para": "Elite Body Home also offers Derma Roller treatment which ensures to make your skin fresh and you look beautiful. The best candidates are people:",
            "items": [
                {
                    "title": "Skin Concerns",
                    "desc": "Worries regarding the acnes, wrinkles and scars on the face.",
                    "icon": "fa-solid fa-face-frown-open"
                },
                {
                    "title": "Skin Improvement",
                    "desc": "Willing to get great skin with a skin procedure.",
                    "icon": "fa-solid fa-face-grin-beam"
                },
                {
                    "title": "All Skin Types",
                    "desc": "Suitable for all skin types including dark and fair.",
                    "icon": "fa-solid fa-people-group"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "",
            "para": "It is not sufficient for just choosing Derma roller therapy. Choose the right aftercare for the best results Elite Body Home is always there with you during the entire procedure and after.",
            "items": [
                {
                    "title": "Keep it Gentle",
                    "desc": "For a day or two, after your treatment, be tender with your skin: Pat rather than scrub. Treat it wisely.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Please dont roam in sunny weather for long. And if you tend to leave the house, wear sunscreen.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Apply Moisturizer",
                    "desc": "Let your skin be happy! And the best way to do is spray a good moisturizing solution on it. And track better skin performance.",
                    "icon": "fa-solid fa-spray-can"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Derma Roller Treatment পরিবর্তন ঘটান.",
            "items": [
                {
                    "title": "Collagen Production",
                    "desc": "Derma roller treatments stimulate collagen production, which increases skin's firmness and elasticity. This process, which creates small micro-injuries, initiates natural healing, thereby stimulating collagen for tauter and more translucent skin.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "Enhances Elasticity and Firmness",
                    "desc": "Derma roller helps you regain the elasticity and firmness in your skin. This procedure smoothes out fine lines and wrinkles and rejuvenates skin from within.",
                    "icon": "fa-solid fa-arrows-up-down-left-right"
                },
                {
                    "title": "Skin Texture and Fine Lines",
                    "desc": "Not only does micro-needling treatment smooth the texture of the skin, but it also helps decrease fine lines. The result gives the patient radiant skin.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Minimize Pores and Wrinkles",
                    "desc": "Forget the pores on your skin and deep wrinkles. It minimizes large pores size. Besides collagen, the treatment produces a stimulating impact on skin tightening. So, it reduces the pores by nature.",
                    "icon": "fa-solid fa-magnifying-glass-minus"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is it okay to wash hair after derma roller treatment in Dubai?",
                    "answer": "Derma rolling can result in varied forms. Right from slight discomfort to intense. The length of the needle and your pain will examine it. However, the numbing cream hps to reduce the pain."
                },
                {
                    "question": "Is it safe to choose a derma roller?",
                    "answer": "Derma roller treatment in Dubai and at Elite Body home are safe to go with."
                },
                {
                    "question": "Are there any side effects or dangers caused with the derma roller treatment?",
                    "answer": "When performed in the right way with serum, derma rolling doesn't have any risk nor any side effects."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Banner-Image-large.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Derma-Roller-Treatment-in-Dubai-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Derma-Roller-Treatment-in-Dubai-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Derma-Roller-Treatment-in-Dubai-3c.jpg"
            ]
        },
        "product": {
            "id": 124,
            "title": "Derma Roller",
            "price": 499,
            "description": "A good skincare always helps to keep skin healthy and refreshed. However, at times we need professional treatment for lasting results and different types of."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج الديرما رولر في دبي، الإمارات العربية المتحدة | إيليت بودي هوم",
            "description": "علاج الديرما رولر هو الحل الأمثل للعديد من مشاكل البشرة مثل ندبات حب الشباب، التجاعيد، الخطوط الدقيقة وعلامات التقدم في السن باستخدام تقنية الميكرونيدلينغ.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/dermaroller/",
            "og": {
                "locale": "ar_AE",
                "type": "article",
                "title": "علاج الديرما رولر في دبي، الإمارات العربية المتحدة | إيليت بودي هوم",
                "description": "علاج الديرما رولر هو الحل الأمثل للعديد من مشاكل البشرة مثل ندبات حب الشباب، التجاعيد، الخطوط الدقيقة وعلامات التقدم في السن باستخدام تقنية الميكرونيدلينغ.",
                "url": "https://elitebodyhome.com/services/dermaroller/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T16:44:48+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-35.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-35.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج الديرما رولر",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "علاج الديرما رولر في دبي، الإمارات العربية المتحدة | إيليت بودي هوم",
                "description": "علاج الديرما رولر هو الحل الأمثل للعديد من مشاكل البشرة مثل ندبات حب الشباب، التجاعيد، الخطوط الدقيقة وعلامات التقدم في السن باستخدام تقنية الميكرونيدلينغ.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-35.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "الديرما رولر"],
        "hero": {
            "title": "علاج الديرما رولر",
            "subtitle": "أفضل علاج الديرما رولر في دبي",
            "description": "تساعد العناية الجيدة بالبشرة دائمًا في الحفاظ على بشرة صحية ومنتعشة. ومع ذلك، يتطلب في بعض الأحيان إلى علاجات متخصصة للحصول على نتائج طويلة الأمد لمعالجة مشاكل البشرة المختلفة. يعتبر علاج الديرما رولر هو الحل الأمثل للعديد من مشاكل البشرة، مثل الأضرار الناتجة عن أشعة الشمس، وعلاج ندبات حب الشباب وعلامات التمدد، والتجاعيد، والخطوط الدقيقة، وعلامات التقدم في السن."
        },
        "howItWorks": {
            "title": "ما هو علاج الديرما رولر؟",
            "description": "يُعد علاج الديرما رولر خيارًا مثاليًا لتعزيز صحة البشرة وتطوير حالتها من الداخل. استعدي لإطلالة جديدة خالية من الندوب، التجاعيد، علامات التمدد، والخطوط الدقيقة! يعتمد العلاج على تقنية الـميكرونيديلينغ (Microneedling) التي تُحفز إنتاج الكولاجين، مما يساعد على تجديد البشرة ومنحها مظهرًا أكثر شبابًا. يتكون الديرما رولر من إبر دقيقة جدًا متواجدة على إحدى أطراف الجهاز. تُحدث هذه الإبر جروح سطحية في الجلد عند تمريرها على البشرة، مما يحفز عملية الشفاء الطبيعية، ويعزز تدفق الدم، ويساعد في التخلص من الندوب، والبقع، والمشكلات الجلدية الأخرى."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء علاج الديرما رولر",
            "para": "إليك خطوات الإجراء بالكامل، بكل سهولة وسلاسة! نتائج رائعة وبشرة مثالية دون تعقيد.",
            "steps": [
                {
                    "title": "الاستشارة مع الخبراء",
                    "desc": "تُنظف البشرة بعمق بواسطة فريقنا المختص من أطباء الجلدية، ثم نوفر لك استشارة شاملة لفهم حالتك بشكل أفضل وضمان نتائج مميزة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التخدير",
                    "desc": "يُستخدم كريم مخدر موضعي على المنطقة المستهدفة قبل 30 دقيقة من بدء العلاج لضمان راحة تامة أثناء الجلسة.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "إجراء الديرما رولر",
                    "desc": "يبدأ الأخصائي بتحريك جهاز الديرما رولر على البشرة بعد إزالة الكريم المخدر. تستغرق هذه الخطوة من 10 إلى 30 دقيقة فقط.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "التنظيف",
                    "desc": "تُنظف البشرة بعمق في الخطوة الأخيرة، ويُستخدم كريم مرطب بعد العلاج.",
                    "icon": "fa-solid fa-soap"
                }
            ]
        },
        "benefits": {
            "heading": "مميزات علاج الديرما رولر",
            "subheading": "",
            "para": "يمنحكِ هذا الإجراء العديد من المزايا التي تساعدكِ على الحصول على بشرة مشرقة وصحية. إليكِ بعض المزايا التي ستساعدكِ على اتخاذ القرار المناسب في إجراء الديرما رولر:",
            "items": [
                {
                    "title": "حل شامل لجميع مشاكل البشرة",
                    "desc": "يساعد في التخلص من التجاعيد، والخطوط الدقيقة، وعلامات التمدد، وفرط التصبغ، والمزيد بكل سهولة مع علاج الديرما رولر!",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "وداعًا للمسام الواسعة",
                    "desc": "يساعد العلاج في تخفيف مظهر المسام الواسعة الناتجة عن التقدم في العمر.",
                    "icon": "fa-solid fa-compress"
                },
                {
                    "title": "وقت تعافي قصير",
                    "desc": "لا يتطلب العلاج فترة تعافي طويلة، مما يعني عدم المعاناة من التوقف عن أنشطتك اليومية. استمتع بأسرع شفاء وتجديد للبشرة لتظهر بإطلالة شبابية وصحية.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "إطلالة رائعة",
                    "desc": "يساعد علاج الديرما رولر في دبي على التجدد الطبيعي للبشرة، مما يمنحك مظهرًا أكثر حيوية وصحة.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المثالي لعلاج الديرما رولر؟",
            "subheading": "",
            "para": "يمنح علاج الديرما رولر في ايليت بودي هوم بشرتك نضارة وإشراقة لا مثيل لها.",
            "items": [
                {
                    "title": "مرضى حب الشباب والندوب",
                    "desc": "يناسب من يعاني من حب الشباب، أو التجاعيد، أو الندوب.",
                    "icon": "fa-solid fa-circle-dot"
                },
                {
                    "title": "الباحثون عن بشرة نقية",
                    "desc": "يناسب من يبحث عن بشرة نقية ومشرقة من خلال إجراء تجميلي فعال.",
                    "icon": "fa-solid fa-search"
                },
                {
                    "title": "جميع أنواع البشرة",
                    "desc": "يناسب جميع أنواع البشرة، سواء الفاتحة أو الداكنة.",
                    "icon": "fa-solid fa-users"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد للعلاج",
            "subheading": "",
            "para": "",
            "items": []
        },
        "results": {
            "heading": "النتائج",
            "subheading": "اكتشف التأثيرات المذهلة لعلاج الديرما رولر",
            "para": "",
            "items": [
                {
                    "title": "تحفيز إنتاج الكولاجين",
                    "desc": "يُحفز علاج الديرما رولر إنتاج الكولاجين، مما يعزز متانة البشرة ومرونتها وذلك عبر إحداث جروح دقيقة جدًا التي بدورها تحفز عملية الشفاء الطبيعية وتزيد الكولاجين فيمنحكِ بشرة أكثر نعومة.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "تعزيز مرونة البشرة",
                    "desc": "يُساعد الديرما رولر على تعزيز مرونة الجلد وشدّه، مما يخفف من الخطوط الدقيقة والتجاعيد، ويجدد البشرة من الداخل.",
                    "icon": "fa-solid fa-repeat"
                },
                {
                    "title": "تنعيم ملمس البشرة",
                    "desc": "يُساهم العلاج بتقنية الميكرونيدل في تخفيف التجاعيد، إلى جانب تعزيز ملمس البشرة، مما يمنحكِ بشرة أكثر نضارة وإشراقًا.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "تخفيف المسام والتجاعيد",
                    "desc": "تخلص من المسام الواسعة والتجاعيد العميقة، حيث يساعد العلاج على تقليص حجم المسام بفضل إنتاج الكولاجين، مما يمنح البشرة تنشيطًا طبيعيًا لشد المسام وتعزيز مظهرها.",
                    "icon": "fa-solid fa-minus"
                }
            ]
        },
        "aftercareTips": {
            "heading": "العناية بالبشرة بعد علاج الديرما رولر",
            "subheading": "",
            "para": "الخضوع لعلاج الديرما رولر وحده لا يكفي للحصول على النتائج المثالية، بل إن اتباع نصائح العناية بعد الجلسة هو المفتاح! يمكنك الاعتماد على ايليت بودي هوم، ستكون معك في كل خطوة حتى بعد انتهاء الإجراء.",
            "items": [
                {
                    "title": "تعامل بلطف مع بشرتك",
                    "desc": "احرص على التعامل مع بشرتك بلطف وتجنب فرك البشرة بعد العلاج ولمدة يوم أو يومان.",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "تجنب التعرض لأشعة الشمس لفترات طويلة، وإن كان يلزم الخروج، تأكد من استخدام واقي الشمس لحماية بشرتك.",
                    "icon": "fa-solid fa-sun-slash"
                },
                {
                    "title": "ترطيب البشرة",
                    "desc": "دلل بشرتك! استخدم مرطبًا جيدًا، ليساعد في تحقيق نتائج أفضل وأسرع.",
                    "icon": "fa-solid fa-droplet"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل علاج الديرما رولر خيار آمن؟",
                    "answer": "نعم، يُعد علاج الديرما رولر في ايليت بودي هوم في دبي علاج آمن تمامًا."
                },
                {
                    "question": "هل هناك آثار جانبية أو مخاطر لعلاج الديرما رولر؟",
                    "answer": "لا يسبب مخاطر أو آثار جانبية عند إجرائه بالطريقة الصحيحة باستخدام السيروم المناسب."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
